////// CUSTOM /////
$(window).bind("load", function () {
    $('.slide-fr').slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000
    });
  });

////// HEADER //////

function myFunction() {
  var input = document.getElementById("Search");
  var filter = input.value.toLowerCase();
  var nodes = document.getElementsByClassName('likovi');

  for (i = 0; i < nodes.length; i++) {
    if (nodes[i].innerText.toLowerCase().includes(filter)) {
      nodes[i].style.display = "block";
    } else {
      nodes[i].style.display = "none";
    }
  }
}

$( "a[href='/pages/brands-we-carry']" ).next().children().prepend( $( ".searbra" ) );

$( ".site-footer__item .h4" ).click(function() {
  $( this ).parent().parent().toggleClass( "foka" );
});

$('a[href="/cart"]').click(function(e) {
    e.preventDefault();
});

/////// END OF HEADER //////

$(".site-nav--has-dropdown a").hover(function() {
$(".main-content").addClass("blur");
});
$(".site-nav--has-dropdown").parent().hover(function() {
$(".main-content").removeClass("blur");
});


$('.img-cont a').click(function(e) {
        e.preventDefault();
    });


$( ".sluckamob" ).click(function() {
  $('body').mouseup(function (e) { 
            var container = $(".sluckadrop"); 
            if(!container.is(e.target) &&  
            container.has(e.target).length === 0) { 
                $(".sluckadrop").removeClass( "klu" );
            } 
        }); 
  $(".sluckadrop").toggleClass( "klu" );
  
});


  $(".sok").on("click", function(e) {
    $(".social-sharing").toggleClass("kme");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is(".social-sharing") === false) {
      $(".social-sharing").removeClass("kme");
    }
  });



$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 


   
 jQuery(function($) {
   var offset = 500;
   var duration = 500;
   $(window).scroll(function() {
     if ($(this).scrollTop() > offset) {
       $('.back-to-top').fadeIn(duration);
     } 
     else {
       $('.back-to-top').fadeOut(duration);
     }
   });
   $('.back-to-top').unbind('click.smoothscroll').bind('click', function(e) {
     e.preventDefault();
     $('html, body').animate( { scrollTop: 0 }, duration);
     return false;
   })
 });


//// LOGIN REGISTER PAGE /////
$(document).ready(function() {
    if($(window).width()<= 500) {
        $( ".grid.logara .gara:first-child h2" ).wrap( "<button class='accordion'></button>" );
            $( ".grid.logara .gara ul" ).wrap( "<div class='panel'></div>" );
    }

  var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
  
});

$( ".quan .qve" ).click(function() {
  $( this ).parent().toggleClass( "makili" );
});

           $(".tkori").click(function(){
  $(this).parent().parent().addClass("removic");
});
     
        



 
//// PRODUCT PAGE CUSTOM FIELDS ///
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

 $(".prohe").click(function(){
  $(".Reviews").addClass("active");
});

////// PRODUCT PAGE READ MORE READ LESS ///
$(".produzi").click(function(){
  $(".quick-skracena").addClass("ukloni");
  $(".quick-produzena").addClass("dodaj");
});

$(".skrati").click(function(){
  $(".quick-skracena").removeClass("ukloni");
  $(".quick-produzena").removeClass("dodaj");
});




///// CALENDAR ////
$(".calbtn").click(function(){
  $(".calendar-outer").addClass("showcal");
});

$('.calendar-outer').on('click', function(e) {
  if (e.target !== this)
    return;
  
 $(this).removeClass("showcal");
});

//// TAB VIDEOS ////



/// PRODUCT PAGE COLOR VARIATION LOGIC ///

var url = window.location.pathname,

path = url.substring(url.lastIndexOf("/") + 1);
$(".color_variations").children("a").each(function() {
    var link = $(this).attr("href");
    if(link.indexOf(path) > -1){
       $(this).addClass("v_active");
       return;
    } 
});


///// PRODUCT PAGE WARANTY LOGIC ////
$(".warranty input").on("click", function() {
    $(this).parent().siblings(".warranty").removeClass("ware")
    $(this).parent().toggleClass("ware")
});









  $('.tkoslavaparent .btn').click( function() {
    setTimeout( function(){
location.reload()
      }, 200); 
});

$('.cart__remove').click( function() {
    setTimeout( function(){
location.reload()
      }, 200); 
});

$('.clickable svg').on('click', function(e) {
  
  $('.modall').toggleClass('is-visible');
});



$(".srw-widget-address").ready(function(){
   console.log("I showed up");   
});

   //// PRODUCT PAGE TITLE ////

$('h1#titla').html(function(i, v) {
    return v.replace(/\s(.*?)\s/, ' <span>$1</span> ');
});
    
    ////// EXTENDED PROTECTION PAGE /////
$('.slider_outer').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

    
    $('.brandce').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
  infinite: false,
  speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
  infinite: false,
  speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    

$('.img-main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.img-tumb',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    
    

    
    
$('.img-tumb').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.img-main',
  dots: false,
  centerMode: false,
   infinite: true,
  focusOnSelect: true
});
    

    
    

    
    $('.img-tumb-mob').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  centerMode: true,
  focusOnSelect: true
});
    
     $('.img-cont-moka').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.img-cont-mokatu'
});
$('.img-cont-mokatu').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.img-cont-moka',
  dots: false,
  centerMode: true,
  focusOnSelect: true
});

   
    /// CUSTOM COLLECTION PAGES ///

$(function() {
  $(".upitnik").on("click", function(e) {
    $('.upitnik').not(this).removeClass('kumara');
    $(this).toggleClass("kumara");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is(".descra") === false) {
      $(".upitnik").removeClass("kumara");
    }
  });
});
    
    ////
    
    $(function() {
  $(".mupi").on("click", function(e) {
    $('.mupi').not(this).removeClass('kum');
    $(this).toggleClass("kum");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is(".emty-desc") === false) {
      $(".mupi").removeClass("kum");
    }
  });
});


/////// CART PAGE /////////

  $(".reba_activusa").on("click", function(e) {
    $(this).next().addClass("active");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is(".rebatusa") === false) {
      $(".rebatusa").removeClass("active");
    }
  });

$(document).on('change','.cart__row',function(){
    
    setTimeout(function() { 
        $( "#foka" ).load(window.location.href + " .marmun" );
    }, 1000);
    
       

    });

////////// APPLIANCE SERVICES //////
$( "a[href='https://booking.rossware.com/schedule/4582']" ).click(function( event ) {
  event.preventDefault();
  $(".booking").addClass("visible");
});

$( ".close" ).click(function( event ) {
  $(".booking").removeClass("visible");
});





// PRODUCT //
// Get the button element with the ID "AddToCart"
const addToCartButton = document.getElementById("AddToCart");

// Check if the button is disabled
if (addToCartButton.disabled) {
  // Set the innerHTML of the button to "DISCONTINUED"
  addToCartButton.innerHTML = "DISCONTINUED";
}









